import { render, staticRenderFns } from "./sharesperuser.vue?vue&type=template&id=26e0b474"
import script from "./sharesperuser.vue?vue&type=script&lang=js"
export * from "./sharesperuser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports